/* ==========================================================================
   OUTLYRS CLUB — oc-quick-add.js
   Quiet corner (+) quick-add-to-cart from product cards (homepage + catalog).
   - Single-variant products add immediately.
   - One-option products reveal an inline size/option panel (+ rotates to ×).
   - Adds via the Cart AJAX API, then dispatches `cart:added` so the existing
     cart drawer opens + refreshes (see cart.js). Refreshes cart counts too.
   - Loading (spinner) / added (check) / unavailable / sold-out / error states,
     with a per-control busy lock so repeated clicks never double-add.
   ========================================================================== */
(function () {
  "use strict";

  var inFlight = new WeakSet(); // locks a [data-oc-qa] container while a request runs
  var msgTimers = new WeakMap();

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  /* Records the last quick-add failure for later inspection. */
  function logFailure(detail) {
    try {
      var entry = { when: new Date().toISOString(), url: window.location.href, ua: navigator.userAgent };
      for (var k in detail) { if (Object.prototype.hasOwnProperty.call(detail, k)) entry[k] = detail[k]; }
      console.error("[Outlyrs] Quick add failed", entry);
      sessionStorage.setItem("oc_last_cart_error", JSON.stringify(entry));
    } catch (e) {}
  }

  function setMsg(qa, text, isError) {
    var msg = qa.querySelector("[data-oc-qa-msg]");
    if (!msg) return;
    msg.textContent = text || "";
    msg.classList.toggle("pcard__qa-msg--err", !!isError);
    if (text) {
      msg.classList.add("is-show");
      clearTimeout(msgTimers.get(qa));
      msgTimers.set(qa, setTimeout(function () { msg.classList.remove("is-show"); }, 2400));
    } else {
      msg.classList.remove("is-show");
    }
  }

  function closePanel(qa) {
    var panel = qa.querySelector("[data-oc-qa-panel]");
    var toggle = qa.querySelector("[data-oc-qa-toggle]");
    if (panel) panel.hidden = true;
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  }

  function updateCounts(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = "(" + cart.item_count + ")"; });
    document.querySelectorAll("[data-cart-count-drawer]").forEach(function (el) { el.textContent = "(" + cart.item_count + ")"; });
    document.querySelectorAll("[data-cart-count-mobile]").forEach(function (el) { el.textContent = cart.item_count; });
  }

  function refreshCounts() {
    return fetch(root() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCounts(cart); })
      .catch(function () {});
  }

  function flashAdded(qa, clicked) {
    // Show the check on the round (+) control: the toggle if this was a size chip, else the button itself.
    var target = clicked.classList.contains("pcard__qa-opt")
      ? qa.querySelector("[data-oc-qa-toggle]")
      : clicked;
    if (!target) return;
    target.classList.add("is-added");
    setTimeout(function () { target.classList.remove("is-added"); }, 1600);
  }

  function addToCart(button, qa) {
    if (inFlight.has(qa)) return;                 // duplicate-click guard (per card)
    if (button.disabled || button.classList.contains("is-loading")) return;

    var id = button.getAttribute("data-variant-id");
    if (!id) return;

    inFlight.add(qa);
    button.classList.remove("is-added");
    button.classList.add("is-loading");
    setMsg(qa, "");

    fetch(root() + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json()
          .catch(function () { return {}; })
          .then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var d = result.data || {};
          var msg = d.description || d.message || "Unavailable";
          setMsg(qa, msg, true);
          logFailure({ stage: "quick-add", status: result.status, message: msg, variant: id, body: d });
          return;
        }
        flashAdded(qa, button);
        closePanel(qa);
        return refreshCounts().then(function () {
          document.dispatchEvent(new CustomEvent("cart:added", { bubbles: true, detail: { item: result.data } }));
        });
      })
      .catch(function (err) {
        setMsg(qa, "Network error — try again.", true);
        logFailure({ stage: "quick-add-network", variant: id, message: err && err.message ? err.message : String(err) });
      })
      .finally(function () {
        inFlight.delete(qa);
        button.classList.remove("is-loading");
      });
  }

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-oc-qa-toggle]");
    if (toggle) {
      var qaT = toggle.closest("[data-oc-qa]");
      var panel = qaT && qaT.querySelector("[data-oc-qa-panel]");
      if (panel) {
        var willOpen = panel.hidden;
        document.querySelectorAll("[data-oc-qa-panel]").forEach(function (p) {
          if (p !== panel) { p.hidden = true; var t = p.closest("[data-oc-qa]").querySelector("[data-oc-qa-toggle]"); if (t) t.setAttribute("aria-expanded", "false"); }
        });
        panel.hidden = !willOpen;
        toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      }
      return;
    }

    var addBtn = e.target.closest("[data-oc-qa-add]");
    if (addBtn) {
      var qa = addBtn.closest("[data-oc-qa]");
      if (qa) addToCart(addBtn, qa);
    }
  });

  // Close an open inline panel when clicking elsewhere.
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-oc-qa]")) return;
    document.querySelectorAll("[data-oc-qa-panel]").forEach(function (p) {
      if (!p.hidden) {
        p.hidden = true;
        var t = p.closest("[data-oc-qa]").querySelector("[data-oc-qa-toggle]");
        if (t) t.setAttribute("aria-expanded", "false");
      }
    });
  });
})();
